<template>
    <div class="sidebar">
        <el-menu active-text-color="#fff" text-color="#fff" background-color="transparent" class="sidebar-menu"
                 :default-active="$route.path.split('/').length>2?('/'+$route.path.split('/')[1]):$route.path"
                 :default-openeds="SideOpen"
                 :collapse="isCollapse"
                 unique-opened router
                 @select="handleMenuSelect">

            <el-menu-item index="/account" class="accountMenuItem">
                <div class="sidebar-user">
                    <div class="sidebar-avatar">
                        <img v-if="getCompanyLogoUrlByCompany(selectedCompany) !== '' && !isCompanyLogoFailed(selectedCompany)"
                             class="sidebar-avatar-image"
                             :class="{'is-visible': isCompanyLogoLoaded(selectedCompany)}"
                             :src="getCompanyLogoUrlByCompany(selectedCompany)"
                             alt=""
                             @load="markCompanyLogoLoaded(selectedCompany)"
                             @error="markCompanyLogoFailed(selectedCompany)">
                        <i v-if="getCompanyLogoUrlByCompany(selectedCompany) !== '' && !isCompanyLogoFailed(selectedCompany) && !isCompanyLogoLoaded(selectedCompany)"
                           class="el-icon-loading company-logo-loading"></i>
                        <span v-if="getCompanyLogoUrlByCompany(selectedCompany) === '' || isCompanyLogoFailed(selectedCompany)">
                            {{getCompanyInitial(selectedCompany)}}
                        </span>
                    </div>
                    <div class="sidebar-user-content">
                        <div class="sidebar-user-name">{{selectedCompany ? selectedCompany.companyName : ''}}</div>
                        <div class="sidebar-user-email">{{loginEmail}}</div>
                    </div>
                    <div class="companyDropdownWrapper" @click.stop>
                        <el-dropdown trigger="click"
                                     class="companyDropdown"
                                     @visible-change="handleCompanyDropdownVisible"
                                     @command="handleCompanyCommand">
                            <button type="button" class="companyArrowButton" :aria-label="$t('common.change')">
                                <i class="el-icon-arrow-down companyArrow"></i>
                            </button>
                            <el-dropdown-menu slot="dropdown" class="companyDropdownMenu sidebar-popup-menu" :visible-arrow="false">
                                <el-dropdown-item
                                        v-for="company in dropdownCompanyList"
                                        :key="company.innerUUID"
                                        :command="company.innerUUID"
                                        :class="{'is-active': selectedCompany && selectedCompany.innerUUID === company.innerUUID}"
                                    class="companyDropdownItem">
                                    <div class="companyOption">
                                        <div class="companyOptionLogo" v-if="getCompanyLogoUrlByCompany(company) !== '' && !isCompanyLogoFailed(company)">
                                            <img class="companyOptionLogoImage"
                                                 :style="{
                                                     maxWidth: '100px',
                                                     maxHeight: '50px',
                                                     width: 'auto',
                                                     height: 'auto',
                                                     objectFit: 'contain',
                                                     display: isCompanyLogoLoaded(company) ? 'block' : 'none'
                                                 }"
                                                 :src="getCompanyLogoUrlByCompany(company)"
                                                 alt=""
                                                 @load="markCompanyLogoLoaded(company)"
                                                 @error="markCompanyLogoFailed(company)">
                                            <i v-if="!isCompanyLogoLoaded(company)"
                                               class="el-icon-loading company-logo-loading"></i>
                                        </div>
                                        <span class="companyOptionName" :title="company.companyName">{{company.companyName}}</span>
                                        <i v-if="selectedCompany && selectedCompany.innerUUID === company.innerUUID"
                                           class="el-icon-check company-selected-icon" aria-hidden="true"></i>
                                    </div>
                                </el-dropdown-item>
                                <el-dropdown-item divided :command="addBusinessCommand" class="companyDropdownItem addBusinessItem">
                                    <div class="addBusinessOption">
                                        <i class="el-icon-plus"></i>
                                        <span>{{$t('menu.addBusiness')}}</span>
                                    </div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </el-menu-item>

            <el-menu-item index="/invoice">
                <svg class="sidebar-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z"/>
                    <path d="M14 3v6h6M8 13h8M8 17h5"/>
                </svg>
                <span class="menuValue">{{getDocumentMenuLabel(userSetting.invoiceLabel, 'menu.invoices')}}</span>
            </el-menu-item>

            <el-menu-item index="/estimate">
                <svg class="sidebar-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M10 21H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8l6 6v1M14 3v6h6M8 12h4M8 16h2"/>
                    <path d="m13 20 2.8-.6 6.6-6.6a1.7 1.7 0 0 0-2.4-2.4l-6.6 6.6-.4 3ZM18.5 11.9l2.4 2.4"/>
                </svg>
                <span class="menuValue">{{getDocumentMenuLabel(userSetting.estimateLabel, 'menu.estimates')}}</span>
            </el-menu-item>

            <el-menu-item index="/purchaseOrder">
                <svg class="sidebar-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <rect x="8" y="3" width="8" height="4" rx="1"/>
                    <path d="M8 5H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M8 12l1 1 2-2M14 12h3M8 17l1 1 2-2M14 17h3"/>
                </svg>
                <span class="menuValue">{{getDocumentMenuLabel(userSetting.purchaseOrderLabel, 'menu.purchaseOrders')}}</span>
            </el-menu-item>

            <el-menu-item index="/creditMemo">
                <svg class="sidebar-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Z"/>
                    <path d="M14 3v6h6M8 15h8"/>
                </svg>
                <span class="menuValue">{{getDocumentMenuLabel(userSetting.creditMemoLabel, 'menu.creditMemos')}}</span>
            </el-menu-item>
            <li class="sidebar-menu-divider" role="separator"></li>

            <el-menu-item index="/item">
                <svg class="sidebar-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="m12 3 9 5v9l-9 5-9-5V8ZM3 8l9 5 9-5M12 13v9M7.5 5.5l9 5"/>
                </svg>
                <span class="menuValue">{{$t('menu.items')}}</span>
            </el-menu-item>
            <el-menu-item index="/client">
                <svg class="sidebar-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M17 3a4 4 0 0 1 0 8M22 21v-2a4 4 0 0 0-3-3.9"/>
                </svg>
                <span class="menuValue">{{$t('menu.clients')}}</span>
            </el-menu-item>

            <el-menu-item index="/expense">
                <svg class="sidebar-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M20 8V6H5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-3M3 8V5a2 2 0 0 1 2-2h12v3"/>
                    <path d="M17 10h4v6h-4a3 3 0 0 1 0-6ZM17.5 13h.01"/>
                </svg>
                <span class="menuValue">{{$t('menu.expenses')}}</span>
            </el-menu-item>

            <el-menu-item index="/time">
                <svg class="sidebar-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <circle cx="12" cy="12" r="9"/>
                    <path d="M12 7v5l3 2"/>
                </svg>
                <span class="menuValue">{{$t('menu.time')}}</span>
            </el-menu-item>
            <li class="sidebar-menu-divider" role="separator"></li>

            <el-menu-item v-if="showReportMenu" index="/report">
                <svg class="sidebar-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M3 3v18h18M8 16v-4M13 16V8M18 16V5"/>
                </svg>
                <span class="menuValue">{{$t('menu.reports')}}</span>
            </el-menu-item>
            <li v-if="showReportMenu" class="sidebar-menu-divider" role="separator"></li>


            <el-submenu index="/setting">
                <template slot="title">
                    <svg class="sidebar-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M10 3h4l.5 2.2 2 1.2 2.2-.7 2 3.4-1.7 1.5v2.8l1.7 1.5-2 3.4-2.2-.7-2 1.2L14 21h-4l-.5-2.2-2-1.2-2.2.7-2-3.4L5 13.4v-2.8L3.3 9.1l2-3.4 2.2.7 2-1.2Z"/>
                        <circle cx="12" cy="12" r="3"/>
                    </svg>
                    <span class="menuValue">{{$t('menu.settings')}}</span>
                </template>
                <el-menu-item-group class="subMenuValue">
                    <el-menu-item index="/company_info" class="sidebar-submenu-child">
                        <svg class="sidebar-submenu-icon" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M3 21h18M5 21V3h14v18M10 21v-4h4v4M9 7h.01M15 7h.01M9 11h.01M15 11h.01"/>
                        </svg>
                        <span>{{$t('menu.companyInfo')}}</span>
                    </el-menu-item>
                    <el-menu-item index="/setting" class="sidebar-submenu-child">
                        <svg class="sidebar-submenu-icon" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="m6 18 12-12"/>
                            <circle cx="7" cy="7" r="2"/>
                            <circle cx="17" cy="17" r="2"/>
                        </svg>
                        <span>{{$t('menu.taxes')}}</span>
                    </el-menu-item>
                    <el-menu-item index="/default" class="sidebar-submenu-child">
                        <svg class="sidebar-submenu-icon" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M3 6h3M10 6h11M3 12h11M18 12h3M3 18h5M12 18h9"/>
                            <circle cx="8" cy="6" r="2"/>
                            <circle cx="16" cy="12" r="2"/>
                            <circle cx="10" cy="18" r="2"/>
                        </svg>
                        <span>{{$t('menu.default')}}</span>
                    </el-menu-item>
                    <el-menu-item index="/invoice-design" class="sidebar-submenu-child">
                        <svg class="sidebar-submenu-icon" viewBox="0 0 24 24" aria-hidden="true">
                            <rect x="3" y="3" width="18" height="18" rx="2"/>
                            <path d="M3 9h18M9 9v12M13 13h4M13 17h4"/>
                        </svg>
                        <span>{{$t('menu.customizeInvoice')}}</span>
                    </el-menu-item>
                </el-menu-item-group>
            </el-submenu>

            <el-menu-item index="/feedback">
                <svg class="sidebar-menu-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2ZM7 8h10M7 12h6"/>
                </svg>
                <span class="menuValue">{{$t('menu.sendFeedback')}}</span>
                <span v-if="loginEmail === 'dg@hazkargo.com'" class="feedback-reply-badge">{{$t('menu.newReply')}}</span>
            </el-menu-item>


        </el-menu>
        <div v-if="showTrialNotice" class="sidebar-trial-notice">
            <div class="sidebar-trial-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none">
                    <path d="m4 7 4 4 4-7 4 7 4-4-2 11H6L4 7Z"
                          stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
                    <path d="M7 21h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
            <div class="sidebar-trial-content">
                <div class="sidebar-trial-text">
                    {{$t('menu.trialDaysLeft', {days: trialDaysRemaining})}}
                </div>
                <button type="button" class="sidebar-trial-upgrade" @click="openTrialUpgrade">
                    {{$t('menu.upgradeAccount')}}
                </button>
            </div>
        </div>
        <div class="sidebar-lang-switcher">
            <el-dropdown trigger="click" @command="switchLang" placement="top">
                <button type="button" class="sidebar-lang-trigger" :aria-label="$t('language.label')">
                    <svg class="sidebar-language-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <circle cx="12" cy="12" r="8"/>
                        <path d="M4 12h16M12 4c2 2 3 5 3 8s-1 6-3 8c-2-2-3-5-3-8s1-6 3-8Z"/>
                    </svg>
                    <span class="sidebar-lang-current">{{currentLangLabel}}</span>
                    <i class="el-icon-arrow-up sidebar-lang-caret"></i>
                </button>
                <el-dropdown-menu slot="dropdown" class="sidebar-lang-menu sidebar-popup-menu" :visible-arrow="false">
                    <el-dropdown-item v-for="lang in langList"
                                      :key="lang.code"
                                      :command="lang.code"
                                      :class="{'is-active': $i18n.locale === lang.code}">
                        <span>{{lang.label}}</span>
                        <i v-if="$i18n.locale === lang.code" class="el-icon-check" aria-hidden="true"></i>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <button type="button" class="signOutButton" @click="loginOutDialog = true">
            <svg class="sidebar-sign-out-icon" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M9 4H4v16h5M10 12h11m-4-4 4 4-4 4"/>
            </svg>
            <span>{{$t('menu.signOut')}}</span>
        </button>
        <el-dialog
                :title="$t('menu.signOut')"
                :visible.sync="loginOutDialog"
                append-to-body
                custom-class="sidebar-action-dialog"
                width="30%">
            <span>{{$t('menu.signOutConfirm')}}</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="loginOutDialog = false">{{$t('common.cancel')}}</el-button>
                <el-button type="primary" :disabled="buttonDisabledStatus" :loading="loading" @click="loginOut()">{{$t('menu.signOut')}}</el-button>
              </span>
        </el-dialog>
        <el-dialog
                :title="$t('menu.newBusinessTitle')"
                :visible.sync="createCompanyDialog"
                :close-on-click-modal="!createCompanyLoading"
                :close-on-press-escape="!createCompanyLoading"
                append-to-body
                width="480px"
                custom-class="create-company-dialog">
            <el-form @submit.native.prevent="createCompany">
                <el-form-item :label="$t('menu.businessName')">
                    <el-input
                            ref="companyNameInput"
                            v-model="newCompanyName"
                            :placeholder="$t('menu.businessNamePlaceholder')"
                            @keyup.enter.native="createCompany">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :disabled="createCompanyLoading" @click="createCompanyDialog = false">{{$t('common.cancel')}}</el-button>
                <el-button type="primary" :loading="createCompanyLoading" @click="createCompany">{{$t('menu.createBusiness')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        applyCompanySelectionByIndex,
        applyCompanySelectionByUUID,
        getCurrentCompany,
        getCurrentSetting,
        getSelectedCompanyIndex,
        getStoredCompanyList,
        syncCompanySelection
    } from '@/utils/company'
    import {getStoredImageDownloadUrl} from '@/utils/fileUpload'
    import {uuid} from '@/utils/validate'
    import {clearSentryUser} from '@/utils/sentry'
    import {invalidateCurrentTabAuthentication} from '@/utils/authTabState'
    import {
        canCreateNewCompany,
        getTrialDaysRemaining,
        getActiveCompanyList,
        getCurrentPlanName,
        isActiveTrial,
        openFastSpringPage
    } from '@/utils/subscription'

    const LANG_LIST = [
        {code: 'en', label: 'English'},
        {code: 'zh', label: '中文'},
        {code: 'fr', label: 'Français'},
        {code: 'de', label: 'Deutsch'},
        {code: 'es', label: 'Español'},
        {code: 'ja', label: '日本語'},
        {code: 'ms', label: 'Bahasa Melayu'},
        {code: 'id', label: 'Bahasa Indonesia'},
        {code: 'tl', label: 'Filipino'}
    ];

    export default {
        name: "leftMenu",
        data() {
            return {
                SideOpen: ["setting"],
                loginOutDialog: false,
                isCollapse: false,
                pt: '',
                loginEmail: "",
                buttonDisabledStatus: false,
                loading: false,
                companyList: [],
                selectedCompany: null,
                companyLogoMap: {},
                companyLogoMapLoaded: false,
                failedLogoCompanyUUIDMap: {},
                loadedLogoCompanyUUIDMap: {},
                switchCompanyLoading: false,
                showReportMenu: true,
                addBusinessCommand: '__add_business__',
                createCompanyDialog: false,
                createCompanyLoading: false,
                newCompanyName: '',
                loginInformation: null,
                userSetting: {},
                langList: LANG_LIST
            }
        },
        computed: {
            currentLangLabel() {
                const found = LANG_LIST.find(l => l.code === this.$i18n.locale);
                return found ? found.label : 'English';
            },
            showTrialNotice() {
                return this.loginInformation != null && isActiveTrial(this.loginInformation);
            },
            trialDaysRemaining() {
                if (!this.showTrialNotice) {
                    return null;
                }
                return getTrialDaysRemaining(this.loginInformation);
            },
            dropdownCompanyList() {
                let list = this.companyList && this.companyList.length > 0
                    ? getActiveCompanyList(this.companyList)
                    : [];
                const current = this.selectedCompany != null ? this.selectedCompany : getCurrentCompany();
                if (current != null && current.syncStatus !== 1) {
                    const exists = list.some(item => item.innerUUID === current.innerUUID);
                    if (!exists) {
                        list.unshift(current);
                    }
                }
                return list;
            }
        },
        methods: {
            getDocumentMenuLabel(label, defaultKey) {
                const menuLabel = label == null ? '' : String(label).trim();
                const displayLabel = menuLabel === '' ? this.$t(defaultKey) : menuLabel;
                return displayLabel.toLowerCase().replace(/(^|\s)\S/g, character => character.toUpperCase());
            },
            handleMenuSelect() {
                this.$emit('navigate');
            },
            switchLang(lang) {
                if (this.$i18n.locale === lang) {
                    return;
                }
                this.$i18n.locale = lang;
            },
            openTrialUpgrade() {
                const currentPlan = getCurrentPlanName(this.loginInformation);
                openFastSpringPage(currentPlan, currentPlan === 'Premium' ? 'Premium' : 'Pro');
            },
            loginOut() {
                let that = this;
                this.loading = true;
                this.buttonDisabledStatus = true;
                this.$axios.post('login_out', {
                    params: {}
                }).then(() => {
                    clearSentryUser();
                    invalidateCurrentTabAuthentication();
                    localStorage.clear();
                    that.$router.replace('/login');
                    this.buttonDisabledStatus = false;
                    this.loading = false;
                }).catch(function () {
                    that.buttonDisabledStatus = false;
                    that.loading = false;
                })
            },
            loadCompanyListFromStorage() {
                this.companyList = getStoredCompanyList();
                const selectedCompanyIndex = getSelectedCompanyIndex();
                if (selectedCompanyIndex >= 0 && selectedCompanyIndex < this.companyList.length) {
                    this.selectedCompany = this.companyList[selectedCompanyIndex];
                    return;
                }
                this.selectedCompany = null;
            },
            loadCompanyListIfNeeded() {
                this.loadCompanyListFromStorage();
                if (this.companyList.length > 0 && this.companyLogoMapLoaded) {
                    return;
                }
                this.switchCompanyLoading = true;
                let that = this;
                this.$axios.post('query_setting_and_company', {
                    params: {}
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        let selectedData = syncCompanySelection(response.data);
                        that.companyLogoMap = response.data.companyLogoMap;
                        that.companyLogoMapLoaded = true;
                        that.failedLogoCompanyUUIDMap = {};
                        that.loadedLogoCompanyUUIDMap = {};
                        that.companyList = getStoredCompanyList();
                        if (selectedData != null) {
                            that.selectedCompany = that.companyList[selectedData.index];
                            that.userSetting = selectedData.setting;
                        }
                    }
                    that.switchCompanyLoading = false;
                }).catch(function () {
                    that.switchCompanyLoading = false;
                })
            },
            handleCompanyDropdownVisible(visible) {
                if (visible) {
                    this.loadCompanyListIfNeeded();
                }
            },
            handleCompanyCommand(companyUUID) {
                if (companyUUID === this.addBusinessCommand) {
                    this.openCreateCompanyDialog();
                    return;
                }
                const index = this.companyList.findIndex(item => item.innerUUID === companyUUID);
                if (index === -1 || index === getSelectedCompanyIndex()) {
                    return;
                }
                let currentSelection = applyCompanySelectionByIndex(index);
                if (currentSelection == null) {
                    return;
                }
                window.location.reload();
            },
            openCreateCompanyDialog() {
                const loginInformation = JSON.parse(localStorage.getItem('loginInformation')).objectData;
                if (!canCreateNewCompany(loginInformation)) {
                    openFastSpringPage(getCurrentPlanName(loginInformation), 'Premium');
                    return;
                }
                this.newCompanyName = '';
                this.createCompanyDialog = true;
                this.$nextTick(() => {
                    this.$refs.companyNameInput.focus();
                });
            },
            async createCompany() {
                if (this.createCompanyLoading) {
                    return;
                }
                const companyName = this.newCompanyName.trim();
                if (companyName === '') {
                    this.$message.error(this.$t('menu.businessNameRequired'));
                    return;
                }
                const companyUUID = uuid(null, 37);
                this.createCompanyLoading = true;
                let companyCreated = false;
                try {
                    const createResponse = await this.$axios.post('web_create_company', {
                        params: {
                            companyName: companyName,
                            companyUUID: companyUUID,
                            settingUUID: uuid(null, 37)
                        }
                    });
                    if (createResponse.data.errorCode !== 0
                        || createResponse.data.objectData == null
                        || createResponse.data.objectData.innerUUID !== companyUUID) {
                        throw new Error('Company create failed');
                    }
                    companyCreated = true;
                    const contextResponse = await this.$axios.post('query_setting_and_company', {params: {}});
                    if (contextResponse.data.errorCode !== 0) {
                        throw new Error('Company list refresh failed');
                    }
                    syncCompanySelection(contextResponse.data);
                    applyCompanySelectionByUUID(companyUUID);
                    this.$message.success(this.$t('menu.createBusinessSuccess'));
                    window.location.reload();
                } catch {
                    if (companyCreated) {
                        this.createCompanyDialog = false;
                        this.$message.error(this.$t('common.loadFailed'));
                    } else {
                        this.$message.error(this.$t('common.saveFailed'));
                    }
                } finally {
                    this.createCompanyLoading = false;
                }
            },
            getCompanyLogoUrl(companyLogo) {
                return getStoredImageDownloadUrl(this.$store.state.requestURL, companyLogo);
            },
            getCompanyLogoUrlByCompany(company) {
                if (company == null) {
                    return "";
                }
                let companyLogo = this.companyLogoMap[company.innerUUID];
                if (companyLogo == null) {
                    return "";
                }
                if (companyLogo.syncStatus === 1) {
                    return "";
                }
                return this.getCompanyLogoUrl(companyLogo);
            },
            markCompanyLogoFailed(company) {
                if (company == null) {
                    return;
                }
                this.$set(this.failedLogoCompanyUUIDMap, company.innerUUID, true);
            },
            markCompanyLogoLoaded(company) {
                if (company == null) {
                    return;
                }
                this.$set(this.loadedLogoCompanyUUIDMap, company.innerUUID, true);
            },
            isCompanyLogoFailed(company) {
                if (company == null) {
                    return false;
                }
                return this.failedLogoCompanyUUIDMap[company.innerUUID] === true;
            },
            isCompanyLogoLoaded(company) {
                if (company == null) {
                    return false;
                }
                return this.loadedLogoCompanyUUIDMap[company.innerUUID] === true;
            },
            getCompanyInitial(company) {
                if (company == null || company.companyName == null || company.companyName === "") {
                    return "";
                }
                return company.companyName.substring(0, 1).toUpperCase();
            }
        }, mounted() {
            let loginInformation = JSON.parse(localStorage.getItem("loginInformation"));
            if (null != loginInformation) {
                this.loginInformation = loginInformation.objectData;
                this.loginEmail = this.loginInformation.email;
            }

            this.loadCompanyListFromStorage();
            this.userSetting = getCurrentSetting() || {};
            this.loadCompanyListIfNeeded();
        }
    }
</script>

<style scoped>
    .sidebar {
        display: flex;
        flex-direction: column;
        flex: 0 0 240px;
        width: 240px;
        min-width: 240px;
        box-sizing: border-box;
        padding: 16px;
        color: rgba(255, 255, 255, 0.78);
        background: linear-gradient(180deg, #13264d 0%, #101d3a 100%);
        border-radius: 0 12px 12px 0;
        box-shadow: 8px 0 32px rgba(17, 37, 76, 0.14);
        height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;
        scrollbar-width: none;
        -ms-overflow-style: none;
        font-family: var(--ui-font-family);
        letter-spacing: 0;
    }

    .sidebar::-webkit-scrollbar {
        display: none;
    }

    .sidebar-menu {
        flex: 1;
        width: 100%;
        min-width: 0;
        padding: 0;
        border: none;
        background: transparent !important;
    }

    .menuValue {
        flex: 1;
        min-width: 0;
        margin-left: 0;
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .sidebar-menu-icon,
    .sidebar-submenu-icon,
    .sidebar-sign-out-icon,
    .sidebar-language-icon {
        display: block;
        fill: none;
        stroke: currentColor;
        stroke-width: 1.75;
        stroke-linecap: round;
        stroke-linejoin: round;
    }

    .sidebar-menu-icon {
        width: 20px;
        height: 20px;
        flex: 0 0 20px;
        margin-right: 12px;
        color: #aab8cf;
    }

    .feedback-reply-badge {
        flex: 0 0 auto;
        padding: 2px 7px;
        border-radius: 9px;
        color: #ffffff;
        background: #F56C6C;
        font-size: 11px;
        font-weight: 600;
        line-height: 16px;
        white-space: nowrap;
    }

    .accountMenuItem {
        height: auto !important;
        line-height: normal !important;
        padding: 0 !important;
        margin: 0 0 16px !important;
        background: transparent !important;
    }

    .accountMenuItem:hover,
    .accountMenuItem:focus,
    .accountMenuItem.is-active {
        background-color: transparent !important;
    }

    .sidebar-user {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 4px 24px;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        cursor: pointer;
    }

    .sidebar-avatar {
        width: 40px;
        height: 40px;
        flex: 0 0 40px;
        display: grid;
        place-items: center;
        overflow: hidden;
        border-radius: 10px;
        color: #ffffff;
        background: #253d65;
        font-size: 20px;
        font-weight: 500;
        line-height: 1;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
    }

    .sidebar-avatar-image {
        width: 100%;
        height: 100%;
        display: none;
        object-fit: contain;
        background: #ffffff;
    }

    .sidebar-avatar-image.is-visible {
        display: block;
    }

    .sidebar-avatar .company-logo-loading {
        color: #ffffff;
        font-size: 20px;
    }

    .sidebar-user-content {
        flex: 1;
        min-width: 0;
    }

    .sidebar-user-name {
        overflow: hidden;
        color: #ffffff;
        font-size: var(--responsive-font-14);
        font-weight: 500;
        line-height: 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .sidebar-user-email {
        margin-top: 2px;
        overflow: hidden;
        color: #aab8cf;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .companyDropdownWrapper {
        flex: 0 0 auto;
    }

    .companyDropdown {
        display: block;
    }

    .companyArrowButton {
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        background: transparent;
        color: #ffffff;
        cursor: pointer;
        padding: 0;
        border-radius: 8px;
        transition: background 160ms ease;
    }

    .companyArrowButton:hover {
        background: rgba(255, 255, 255, 0.06);
    }

    .companyArrow {
        color: rgba(255, 255, 255, 0.72);
        font-size: 16px;
    }

    .sidebar-menu >>> .el-menu-item:not(.accountMenuItem),
    .sidebar-menu >>> .el-submenu__title {
        height: 40px !important;
        line-height: 40px !important;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin: 0 0 4px;
        padding: 0 12px !important;
        border-radius: var(--ui-radius-control);
        color: #ccd5e4 !important;
        background: transparent !important;
        font-size: 14px;
        font-weight: 500;
        transition: color 160ms ease, background 160ms ease;
    }

    .sidebar-menu >>> .el-menu-item:not(.accountMenuItem):hover,
    .sidebar-menu >>> .el-submenu__title:hover {
        color: #ffffff !important;
        background: rgba(255, 255, 255, 0.07) !important;
    }

    .sidebar-menu >>> .el-menu-item.is-active:not(.accountMenuItem):not(.sidebar-submenu-child) {
        color: #ffffff !important;
        background: linear-gradient(110deg, #2c6ddd 0%, #3259c9 60%, #384bb6 100%) !important;
        box-shadow: none;
    }

    .sidebar-menu >>> .el-menu-item.is-active:not(.accountMenuItem):not(.sidebar-submenu-child) .sidebar-menu-icon,
    .sidebar-menu >>> .el-menu-item:not(.accountMenuItem):hover .sidebar-menu-icon,
    .sidebar-menu >>> .el-submenu__title:hover .sidebar-menu-icon,
    .sidebar-menu >>> .el-submenu.is-opened > .el-submenu__title .sidebar-menu-icon {
        color: #ffffff;
    }

    .sidebar-menu-divider {
        height: 1px;
        margin: 8px 12px 12px;
        list-style: none;
        background: rgba(255, 255, 255, 0.1);
    }

    .sidebar-menu >>> .el-submenu.is-opened > .el-submenu__title {
        color: #ffffff !important;
    }

    .sidebar-menu >>> .el-submenu__icon-arrow {
        right: 12px;
        color: rgba(255, 255, 255, 0.72);
        font-weight: 600;
    }

    .subMenuValue {
        margin: 4px 0 8px 22px;
        padding-left: 16px;
        border-left: 1px solid rgba(255, 255, 255, 0.1);
        font-size: 13px;
    }

    .subMenuValue >>> .el-menu-item-group__title {
        display: none;
        padding: 0;
    }

    .subMenuValue >>> .el-menu-item.sidebar-submenu-child {
        min-height: 36px !important;
        height: 36px !important;
        line-height: 36px !important;
        display: flex;
        align-items: center;
        margin: 2px 0;
        padding: 0 12px !important;
        border-radius: var(--ui-radius-control);
        color: #aab8cf !important;
        background: transparent !important;
        box-shadow: none;
        font-size: 13px;
        font-weight: 400;
    }

    .subMenuValue >>> .el-menu-item.sidebar-submenu-child:hover {
        color: #ffffff !important;
        background: rgba(255, 255, 255, 0.06) !important;
    }

    .subMenuValue >>> .el-menu-item.sidebar-submenu-child.is-active {
        color: #d8e6ff !important;
        background: rgba(70, 126, 218, 0.2) !important;
        box-shadow: none;
    }

    .sidebar-submenu-icon {
        width: 18px;
        height: 18px;
        flex: 0 0 18px;
        margin-right: 10px;
        color: currentColor;
    }

    .sidebar-lang-switcher {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
        padding: 16px 0 0;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        box-sizing: border-box;
    }

    .sidebar-lang-switcher >>> .el-dropdown {
        width: 100%;
    }

    .sidebar-trial-notice {
        margin: 12px 2px 0;
        padding: 12px;
        display: flex;
        align-items: center;
        gap: 10px;
        box-sizing: border-box;
        border-radius: 16px;
        color: #17233b;
        background: #ffecad;
        box-shadow: 0 10px 24px rgba(255, 190, 30, 0.18);
    }

    .sidebar-trial-icon {
        width: 38px;
        height: 38px;
        flex: 0 0 38px;
        display: grid;
        place-items: center;
        border-radius: 50%;
        color: #ffffff;
        background: #ffbd13;
    }

    .sidebar-trial-icon svg {
        width: 25px;
        height: 25px;
    }

    .sidebar-trial-content {
        min-width: 0;
        flex: 1;
    }

    .sidebar-trial-text {
        color: #17233b;
        font-size: 12px;
        font-weight: 600;
        line-height: 17px;
    }

    .sidebar-trial-upgrade {
        margin-top: 3px;
        padding: 0;
        color: #1265d8;
        background: transparent;
        border: 0;
        cursor: pointer;
        font-size: 12px;
        font-weight: 700;
        line-height: 17px;
        text-align: left;
        text-decoration: underline;
        text-underline-offset: 2px;
    }

    .sidebar-trial-upgrade:hover,
    .sidebar-trial-upgrade:focus-visible {
        color: #0b4fae;
        outline: none;
    }

    .sidebar-lang-trigger {
        width: 100%;
        height: 40px;
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        gap: 12px;
        box-sizing: border-box;
        padding: 0 12px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: var(--ui-radius-control);
        color: #ccd5e4;
        background: rgba(255, 255, 255, 0.04);
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        transition: background 160ms ease;
    }

    .sidebar-lang-trigger:hover {
        background: rgba(255, 255, 255, 0.08);
    }

    .sidebar-language-icon {
        width: 20px;
        height: 20px;
        flex: 0 0 20px;
    }

    .sidebar-lang-current {
        flex: 1 1 auto;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .sidebar-lang-caret {
        font-size: var(--responsive-font-14);
        margin-left: auto;
    }

    .signOutButton {
        width: 100%;
        height: 40px;
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        gap: 12px;
        box-sizing: border-box;
        margin-top: 8px;
        padding: 0 12px;
        border: 0;
        border-radius: var(--ui-radius-control);
        color: #aab8cf;
        background: transparent;
        cursor: pointer;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        transition: color 160ms ease, background 160ms ease;
    }

    .signOutButton:hover {
        color: #ffffff;
        background: rgba(255, 255, 255, 0.06);
    }

    .sidebar-sign-out-icon {
        width: 20px;
        height: 20px;
        flex: 0 0 20px;
    }

    @media (min-width: 1441px) {
        .sidebar {
            flex-basis: 300px;
            width: 300px;
            min-width: 300px;
        }

        .menuValue,
        .sidebar-menu >>> .el-menu-item:not(.accountMenuItem),
        .sidebar-menu >>> .el-submenu__title {
            font-size: 15px;
        }

        .subMenuValue,
        .subMenuValue >>> .el-menu-item.sidebar-submenu-child {
            font-size: 14px;
        }
    }

    @media (max-width: 900px) {
        .sidebar-menu >>> .el-menu-item:not(.accountMenuItem),
        .sidebar-menu >>> .el-submenu__title {
            height: 44px !important;
            line-height: 44px !important;
        }

        .subMenuValue >>> .el-menu-item.sidebar-submenu-child {
            min-height: 40px !important;
            height: 40px !important;
            line-height: 40px !important;
        }
    }
</style>

<style>
    .sidebar-popup-menu.el-dropdown-menu {
        width: 208px;
        max-width: calc(100vw - 32px);
        max-height: calc(100vh - 160px);
        padding: 6px;
        box-sizing: border-box;
        overflow-y: auto;
        overscroll-behavior: contain;
        border: 1px solid rgba(255, 255, 255, 0.12);
        border-radius: 12px;
        background: #192b4b;
        box-shadow: 0 12px 32px rgba(7, 16, 34, 0.32);
        font-family: var(--ui-font-family);
        letter-spacing: 0;
        scrollbar-width: thin;
        scrollbar-color: #526383 transparent;
    }

    .sidebar-popup-menu.el-dropdown-menu .el-dropdown-menu__item {
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        margin: 2px 0;
        padding: 0 12px;
        border-radius: 8px;
        color: #ccd5e4;
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        transition: color 160ms ease, background 160ms ease;
    }

    .sidebar-popup-menu.el-dropdown-menu .el-dropdown-menu__item:hover,
    .sidebar-popup-menu.el-dropdown-menu .el-dropdown-menu__item:focus {
        color: #ffffff;
        background: rgba(255, 255, 255, 0.07);
    }

    .sidebar-popup-menu.el-dropdown-menu .el-dropdown-menu__item.is-active {
        color: #ffffff;
        background: linear-gradient(110deg, #2c6ddd 0%, #3259c9 60%, #384bb6 100%);
        font-weight: 500;
    }

    .sidebar-popup-menu.el-dropdown-menu .el-dropdown-menu__item:focus-visible {
        outline: 2px solid #b9d6ff;
        outline-offset: -2px;
    }

    .sidebar-popup-menu.el-dropdown-menu .el-dropdown-menu__item > i {
        margin: 0;
        font-size: 16px;
    }

    @media (min-width: 1441px) {
        .sidebar-popup-menu.el-dropdown-menu {
            width: 268px;
        }
    }

    .companyDropdownMenu.el-dropdown-menu {
        width: 320px;
        max-width: calc(100vw - 24px);
    }

    .companyDropdownMenu.el-dropdown-menu .companyDropdownItem {
        min-height: 44px;
        height: auto;
        padding: 8px 12px;
        line-height: 20px;
        box-sizing: border-box;
    }

    .companyDropdownMenu .companyOption {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;
        width: 100%;
        min-height: 28px;
        overflow: hidden;
    }

    .companyDropdownMenu .companyOptionLogo {
        max-width: 100px !important;
        height: 50px !important;
        min-height: 50px !important;
        max-height: 50px !important;
        flex: 0 0 auto !important;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }

    .companyDropdownMenu .companyOptionLogo img,
    .companyDropdownMenu .companyOptionLogoImage {
        max-width: 100px !important;
        max-height: 50px !important;
        width: auto !important;
        height: auto !important;
        object-fit: contain !important;
        display: none;
        background: #ffffff;
    }

    .companyDropdownMenu .companyOptionLogoImage.is-visible {
        display: block;
    }

    .companyDropdownMenu .company-logo-loading {
        color: #aab8cf;
        font-size: 20px;
    }

    .companyDropdownMenu .companyOptionName {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: inherit;
        color: inherit;
    }

    .companyDropdownMenu .company-selected-icon {
        flex: 0 0 16px;
        width: 16px;
        margin: 0;
        font-size: 16px;
    }

    .companyDropdownMenu.el-dropdown-menu .addBusinessItem {
        margin-top: 8px;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        border-radius: 0 0 8px 8px;
        color: #b9d3ff;
    }

    .companyDropdownMenu .addBusinessItem::before {
        display: none;
    }

    .companyDropdownMenu .addBusinessOption {
        min-height: 28px;
        display: flex;
        align-items: center;
        gap: 12px;
        color: inherit;
        font-size: 14px;
        font-weight: 400;
    }

    .companyDropdownMenu .addBusinessOption > i {
        width: 20px;
        height: 20px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: currentColor;
        font-size: 18px;
    }

    .create-company-dialog {
        border-radius: 12px;
    }

    .create-company-dialog .el-dialog__header {
        padding: 24px 26px 12px;
    }

    .create-company-dialog .el-dialog__body {
        padding: 18px 26px 8px;
    }

    .create-company-dialog .el-dialog__footer {
        padding: 16px 26px 24px;
    }

    @media (max-width: 640px) {
        .companyDropdownMenu.el-dropdown-menu {
            width: calc(100vw - 24px) !important;
            min-width: 0 !important;
            max-width: calc(100vw - 24px) !important;
        }

        .create-company-dialog,
        .sidebar-action-dialog {
            width: calc(100vw - 24px) !important;
            max-width: calc(100vw - 24px) !important;
            margin-top: 12px !important;
        }
    }
</style>
